export default "__VITE_PUBLIC_ASSET__22f24f7d__"